import React, { Fragment } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { MdClose } from 'react-icons/md'

import FiveMinutesAlarmModal from '@components/FiveMinutesAlarmModal/FiveMinutesAlarmModal'

type FiveMinutesAlarmModalProps = {
  show: boolean
  setShow: React.Dispatch<React.SetStateAction<boolean>>
}

const FiveMinutesAlarmModalContainer: React.FC<FiveMinutesAlarmModalProps> = ({
  show,
  setShow,
}) => {
  const closeModal = async () => {
    setShow(false)
  }

  return (
    <Transition.Root show={show} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={closeModal}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className={`fixed inset-0 bg-gray-900 bg-opacity-50 transition-opacity`} />
        </Transition.Child>

        <div className="fixed inset-0 z-10">
          <div className="flex min-h-full justify-center text-center items-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel
                className={
                  'relative transform overflow-hidden rounded-lg bg-white w-[320px] sm:w-[380px] h-[314px] px-4 pt-5 pb-6 text-left shadow-xl transition-all '
                }
              >
                <div className="absolute top-0 right-0 pt-4 pr-4">
                  <button
                    type="button"
                    className="rounded-md bg-white text-black focus:outline-none"
                    onClick={closeModal}
                  >
                    <MdClose size={35} />
                  </button>
                </div>

                <div>
                  <div className="mt-3 text-center sm:mt-5">
                    <div className="mt-2">
                      <FiveMinutesAlarmModal closeModalCallback={closeModal} />
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}

export default React.memo(FiveMinutesAlarmModalContainer)
